/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import "../../index.css";
import "../../App.scss";
import { Layout } from "antd";
import Headers from "./Header";
import Sidemenu from "./Sider";
import IntercomMessenger from "./IntercomMessanger";
const { Content } = Layout;
const Layouts = (props) => {
	const [parserLink, setParserLink] = useState(() => sessionStorage.getItem('parserLink') || '');
	useEffect(() => {
		const handleParserLinkChange = () => {
			setParserLink(sessionStorage.getItem('parserLink') || '');
		};
		window.addEventListener('parserLinkChanged', handleParserLinkChange);
		return () => window.removeEventListener('parserLinkChanged', handleParserLinkChange);
	}, []);
	const isJobTrain = parserLink.toLowerCase().includes('jobtrain');
	return (
		<div className={`bg-img min-h-screen${isJobTrain ? ' jobtrain-bg' : ''}`}>
			<IntercomMessenger />
			<Layout>
				<Headers />
				<Content className="container mx-auto 2xl:max-w-full 2xl:px-4">
					<Layout className="pt-3 pb-5">
						<Sidemenu />
						<Content className="mx-3 lg:ml-5 lg:mr-0 p-3 lg:p-5 bg-white min-h-screen overflow-hidden rounded-md">
							{React.cloneElement(props.children, { ...props, })}
						</Content>
					</Layout>
				</Content>
			</Layout>
		</div>
	);
};
export default Layouts;